/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconMapPinFilled = createSolidComponent("map-pin-filled", "IconMapPinFilled", [
  [
    "path",
    {
      d: "M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z",
      "stroke-width": "0",
      fill: "currentColor"
    }
  ]
]);

export { IconMapPinFilled as default };
//# sourceMappingURL=IconMapPinFilled.js.map
